import React from 'react';

// Hooks
import { useResponsiveScreenWidth } from 'Wpds/hooks/useResponsiveScreenWidth';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

// Types
import { User } from 'Shared/constants/types';

// Components
import WpAvatar from 'Wpds/components/avatar/WpAvatar';

// Styles
import './WorkspaceMemberItem.scss';

type Props = {
  user: User;
};

const WorkspaceMemberItem = ({ user }: Props) => {
  const { isSmall } = useResponsiveScreenWidth({ isAtLeast: true });

  const { id: currentUserId } = useCurrentUser();
  const isCurrentUser = currentUserId === user.id;

  const baseClassName = 'WorkspaceMemberItem';
  return (
    <div className={baseClassName}>
      <WpAvatar avatar={user.avatar} />

      <div className={`${baseClassName}__wrapper`}>
        <p className={`${baseClassName}__wrapper__name`}>
          {user.fullName}
          {isCurrentUser && <span className={`${baseClassName}__wrapper__name__you-label`}>&nbsp;(you)</span>}
        </p>
        {isSmall && <div className={`${baseClassName}__wrapper__email`}>{user.email}</div>}
      </div>
    </div>
  );
};

export default WorkspaceMemberItem;
